export default "https://assets.egbcdn.net/assets/packs/_/images/referrals/icon-gift-c17b02d93937c48439df81b9295a0e8e.png";